var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"app-body"},[_c('div',{staticClass:"s404-img"},[_c('img',{attrs:{"src":_vm.assetsPath + 'static/images/404.jpg'}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }